import { on } from '@ngrx/store';

import { CancelPreauthDialogActions } from './cancel-preauth-dialog.actions';
import { CancelPreauthDialogState } from './cancel-preauth-dialog.state';

export const cancelPreauthDialogReducers = [
    on(
        CancelPreauthDialogActions.cancelPreauthFromRowClicked,
        (state: CancelPreauthDialogState, { transactionId, amountMinor, terminalEpi }) => ({
            ...state,
            target: { transactionId, amountMinor, terminalEpi, cancelling: false },
        }),
    ),
    on(
        CancelPreauthDialogActions.cancelPreauthConfirmed,
        (state: CancelPreauthDialogState): CancelPreauthDialogState => ({
            ...state,
            target: state.target ? { ...state.target, cancelling: true } : undefined,
        }),
    ),
    on(
        CancelPreauthDialogActions.cancelPreauthDismissed,
        CancelPreauthDialogActions.cancelPreauthSuccess,
        (state: CancelPreauthDialogState): CancelPreauthDialogState => ({
            ...state,
            target: undefined,
        }),
    ),
    on(
        CancelPreauthDialogActions.cancelPreauthError,
        (state: CancelPreauthDialogState): CancelPreauthDialogState => ({
            ...state,
            target: state.target ? { ...state.target, cancelling: false } : undefined,
        }),
    ),
];
